export default __webpack_public_path__ + "static/media/bouncing-balls-no-1.ea1ef4af.ogg";